import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
  const [searchParams] = useSearchParams();

  const getParam = (paramName: string) => {
    const paramValue = searchParams.get(paramName);
    return paramValue ? decodeURIComponent(paramValue) : null;
  };

  return { getParam };
};